/**
 * @file utils/math.js math相关工具类
 * @author dingyang(dingyang@baidu.com)
 */

import Big from 'big.js';

// 查找数组中的最大值&最小值
export function getMaxMinValue(data: number[] | object[], key?: any) {
    let min;
    let max;
    if (!data.length) {
        return {max, min};
    }
    max = key ? data[0][key] : data[0];
    min = key ? data[0][key] : data[0];
    for (let i = 1, len = data.length; i < len; i++) {
        const currentData = data[i];
        const value = key ? currentData[key] : currentData;
        value > max && (max = value);
        value < min && (min = value);
    }
    return {max, min};
}

interface ValueInfo {
    value: any;
    min?: number;
    max?: number;
}

export function getLimitedValue(valueInfo: ValueInfo) {
    const {value, min, max} = valueInfo;
    if (isNaN(value)) {
        return null;
    }
    const val = Number(value);

    if (val >= (max as number)) {
        return {limitedValue: max, relation: 'more'};
    }
    if (val <= (min as number)) {
        return {limitedValue: min, relation: 'less'};
    }
    return {limitedValue: val, relation: 'equal'};
}

/**
 * 乘法
 *
 * @param {number} num1 乘数
 * @param {number} num2 乘数
 * @return {number} 积
 */
export function multiply(num1: number, num2: number) {
    const big1 = new Big(num1);
    const mulData = big1.times(num2);
    return parseFloat(mulData);
}

/**
 * 加法
 *
 * @param {number} num1 加数
 * @param {number} num2 加数
 * @return {number} 和
 */
export function add(num1: number, num2: number) {
    const big1 = new Big(num1);
    const addData = big1.plus(num2);
    return parseFloat(addData);
}

/**
 * 减法
 *
 * @param {number} num1 被减数
 * @param {number} num2 减数
 * @return {number} 差
 */
export function subtract(num1: number, num2: number) {
    const m1 = new Big(num1);
    const subData = m1.minus(num2);
    return parseFloat(subData);
}

/**
 * 除法
 *
 * @param {number} num1 被除数
 * @param {number} num2 除数
 * @return {number} 商
 */
export function divide(num1: number, num2: number) {
    const div1 = new Big(num1);
    const div2 = new Big(num2);
    const divData = div1.div(div2);
    return parseFloat(divData);
}
